let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gwtQ2")).then(() => parcelRequire('9nYy9'));